import React, { useEffect, useState } from "react";
import categoryAPI from "../../api/categoryApi";
import { useParams } from "react-router-dom";
import Breadcrump from "../../components/Breadcrump";
import SEO from "../../components/SEO";
import CategoryCard from "../categories/Card";
import ProductCard from "../products/Card";
import {
  Swiper,
  SwiperSlide,
  Autoplay,
  Navigation,
  Pagination,
} from "../homepage/Shared/CustomSwiper";

function DetailPage() {
  const { "*": slug } = useParams();
  const [item, setItem] = useState({});
  const [subcategories, setSubCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [metaData, setMetaData] = useState({});

  const fetchCategoryDetail = async () => {
    try {
      const res = await categoryAPI.details(slug);

      if (res.code === 200) {
        const result = res.data;

        setItem(result?.category);
        setSubCategories(result?.subcategories);
        setProducts(result?.products);
        setMetaData(result?.category?.meta);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
    }
  };

  useEffect(() => {
    fetchCategoryDetail();
  }, [slug]);

  return (
    <>
      <Breadcrump title={item?.name} />

      <SEO meta={metaData} />

{subcategories && subcategories.length > 0 && (
        <section className="subcategory-section py-5">
          <div className="container">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              slidesPerView={1}
              spaceBetween={20}
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000 }}
              breakpoints={{
                0: { slidesPerView: 1.8 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 },
              }}
            >
              {subcategories.map((subcategory, index) => (
                <SwiperSlide key={index}>
                  <CategoryCard item={subcategory} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>
      )}

      {/* PRODUCTS SECTION */}
      {products && products.length > 0 ? (
        <div className="py-4 bg-white">
          <div className="container">
            <div className="flat-animate-tab flat-controltab-nav">
              <div className="text-start">
                <h4 className="section-title">Our Products</h4>
              </div>
              <div className="row g-3 mt-2">
                {products.map((product, index) => (
                  <div
                    className="col-lg-3 col-6 mb-2"
                    key={product._id || index}
                  >
                    <ProductCard item={product} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-5 bg-white">
          <div className="container">
            <div className="text-center">
              <p>No Product Found in {item?.name} category</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
    

export default DetailPage;
